import { Box, Typography, Container, Card, CardHeader, CardContent, Avatar } from '@mui/material';
import React from "react";
import Slider from "react-slick";
import './TestimonialSliderLg.css';
import connectBg from '../../../../images/connect-bg.png';
import groupBg from '../../../../images/Vector 68.png';
import groupBackground from '../../../../images/Vector 76.png';

const connectBgLg = {
    backgroundImage: `url(${connectBg})`,
    backgroundPosition: 'right center',
    backgroundRepeat: 'no-repeat'
}
const teamBgLg = {
    backgroundImage: `url(${groupBg})`,
    backgroundPosition: 'left 2% bottom',
    backgroundRepeat: 'no-repeat'
}
const testimonialRight = {
    backgroundImage: `url(${groupBackground})`,
    backgroundPosition: 'right 2% top',
    backgroundRepeat: 'no-repeat'
}

const NextArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: 1, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="arrow next" onClick={onClick}>
            <i className="fas fa-arrow-right"></i>
        </Box>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: 1, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="arrow prev" onClick={onClick}>
            <i className="fas fa-arrow-left"></i>
        </Box>
    );
};

export default function TestimonialSliderLg() {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        lazyLoad: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    }

    return (
        <Box style={connectBgLg}>
            <Box style={teamBgLg}>
                <Box style={testimonialRight}>
                    <Container sx={{ position: 'relative', mt: 4 }}>
                        <Slider {...settings}>

                            {/* Slide-1 */}
                            <Box sx={{ mb: { xs: 3.25, sm: 5.29, md: 7.33, lg: 9.375 }, p: { sm: 1.5, md: 2, lg: 3 } }} >
                                <Card className="hover-testimonial" sx={{ width: '92%', background: '#FFFFFF', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.08)', borderRadius: '7px' }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                alt=""
                                                src="https://i.ibb.co/4YFNHDT/textimonial1.png"
                                                sx={{ width: { xs: 45, sm: 60, md: 70, lg: 76 }, height: { xs: 45, sm: 60, md: 70, lg: 76 } }}
                                            />
                                        }
                                        title="Lorem Ipsum"
                                        subheader="Tokyo, Japan"
                                    />

                                    <CardContent>
                                        <Typography
                                            sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: { xs: 10, sm: 12, md: 14, lg: 14 }, lineHeight: { xs: '9px', lg: '29px' }, color: '#404040', pb: .5, textAlign: 'left' }}
                                            variant="h1"
                                            noWrap
                                            component="div"
                                        >Awesome Work</Typography>
                                        <Typography
                                            sx={{ fontWeight: { xs: 300, sm: 300 }, fontStyle: 'normal', fontSize: { xs: 8, sm: 10, md: 11, lg: 12 }, lineHeight: { xs: '14px', sm: '16px', md: '18px', lg: '20px' }, color: '#5B5B5B', textAlign: 'justify' }}
                                            variant="h1"
                                            noWrap
                                            component="div"
                                        >Lorem ipsum dolor sit amet, consectetur asbi<br /> adipiscing Amet pharetra, amaecena. Adipiscing<br /> Lorem ipsum dolor sit amet.</Typography>
                                    </CardContent>
                                </Card>
                            </Box>

                            {/* Slide-2 */}
                            <Box sx={{ mb: { xs: 3.25, sm: 5.29, md: 7.33, lg: 9.375 }, p: { sm: 1.5, md: 2, lg: 3 } }}>
                                <Card className="hover-testimonial" sx={{ width: '92%', background: '#FFFFFF', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.08)', borderRadius: '7px' }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                alt=""
                                                src="https://i.ibb.co/51Pp6LF/textimonial2.png"
                                                sx={{ width: { xs: 45, sm: 60, md: 70, lg: 76 }, height: { xs: 45, sm: 60, md: 70, lg: 76 } }}
                                            />
                                        }
                                        title="Lorem Ipsum"
                                        subheader="Tokyo, Japan"
                                    />

                                    <CardContent>
                                        <Typography
                                            sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: { xs: 10, sm: 12, md: 14, lg: 14 }, lineHeight: { xs: '9px', lg: '29px' }, color: '#404040', pb: .5, textAlign: 'left' }}
                                            variant="h1"
                                            noWrap
                                            component="div"
                                        >Awesome Work</Typography>
                                        <Typography
                                            sx={{ fontWeight: { xs: 300, sm: 300 }, fontStyle: 'normal', fontSize: { xs: 8, sm: 10, md: 11, lg: 12 }, lineHeight: { xs: '14px', sm: '16px', md: '18px', lg: '20px' }, color: '#5B5B5B', textAlign: 'justify' }}
                                            variant="h1"
                                            noWrap
                                            component="div"
                                        >Lorem ipsum dolor sit amet, consectetur asbi<br /> adipiscing Amet pharetra, amaecena. Adipiscing<br /> Lorem ipsum dolor sit amet.</Typography>
                                    </CardContent>
                                </Card>
                            </Box>

                            {/* Slide-3 */}
                            <Box sx={{ mb: { xs: 3.25, sm: 5.29, md: 7.33, lg: 9.375 }, p: { sm: 1.5, md: 2, lg: 3 } }}>
                                <Card className="hover-testimonial" sx={{ width: '92%', background: '#FFFFFF', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.08)', borderRadius: '7px' }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                alt=""
                                                src="https://i.ibb.co/Y8XNWVC/textimonial3.png"
                                                sx={{ width: { xs: 45, sm: 60, md: 70, lg: 76 }, height: { xs: 45, sm: 60, md: 70, lg: 76 } }}
                                            />
                                        }
                                        title="Lorem Ipsum"
                                        subheader="Mumbai, India"
                                    />

                                    <CardContent>
                                        <Typography
                                            sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: { xs: 10, sm: 12, md: 14, lg: 14 }, lineHeight: { xs: '9px', lg: '29px' }, color: '#404040', pb: .5, textAlign: 'left' }}
                                            variant="h1"
                                            noWrap
                                            component="div"
                                        >Awesome Work</Typography>
                                        <Typography
                                            sx={{ fontWeight: { xs: 300, sm: 300 }, fontStyle: 'normal', fontSize: { xs: 8, sm: 10, md: 11, lg: 12 }, lineHeight: { xs: '14px', sm: '16px', md: '18px', lg: '20px' }, color: '#5B5B5B', textAlign: 'justify' }}
                                            variant="h1"
                                            noWrap
                                            component="div"
                                        >Lorem ipsum dolor sit amet, consectetur asbi<br /> adipiscing Amet pharetra, amaecena. Adipiscing<br /> Lorem ipsum dolor sit amet.</Typography>
                                    </CardContent>
                                </Card>
                            </Box>

                            {/* Slide-4 */}
                            <Box sx={{ mb: { xs: 3.25, sm: 5.29, md: 7.33, lg: 9.375 }, p: { sm: 1.5, md: 2, lg: 3 } }}>
                                <Card className="hover-testimonial" sx={{ width: '92%', background: '#FFFFFF', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.08)', borderRadius: '7px' }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                alt=""
                                                src="https://i.ibb.co/51Pp6LF/textimonial2.png"
                                                sx={{ width: { xs: 45, sm: 60, md: 70, lg: 76 }, height: { xs: 45, sm: 60, md: 70, lg: 76 } }}
                                            />
                                        }
                                        title="Lorem Ipsum"
                                        subheader="Mumbai, India"
                                    />

                                    <CardContent>
                                        <Typography
                                            sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: { xs: 10, sm: 12, md: 14, lg: 14 }, lineHeight: { xs: '9px', lg: '29px' }, color: '#404040', pb: .5, textAlign: 'left' }}
                                            variant="h1"
                                            noWrap
                                            component="div"
                                        >Awesome Work</Typography>
                                        <Typography
                                            sx={{ fontWeight: { xs: 300, sm: 300 }, fontStyle: 'normal', fontSize: { xs: 8, sm: 10, md: 11, lg: 12 }, lineHeight: { xs: '14px', sm: '16px', md: '18px', lg: '20px' }, color: '#5B5B5B', textAlign: 'justify' }}
                                            variant="h1"
                                            noWrap
                                            component="div"
                                        >Lorem ipsum dolor sit amet, consectetur asbi<br /> adipiscing Amet pharetra, amaecena. Adipiscing<br /> Lorem ipsum dolor sit amet.</Typography>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Slider>
                    </Container >
                </Box>
            </Box>
        </Box>
    );
}